import {takeLatest, put, all} from 'redux-saga/effects';
import types from '../../../../../../../actions/types';
import {push} from 'react-router-redux';

import {fetchItemSaga, handleFormUpdate} from '../../../../../../../sagas/common-sagas';

function* getGameSaga(action) {
    yield fetchItemSaga(`/api/games/${action.payload.id}/`, types.GET_GAME);
}

function* saveGameSage(action) {
    yield handleFormUpdate(`/api/games/${action.payload.data.id}/`, action, types.SAVE_GAME);
}

function* getGameFailure() {
    yield put(push('/app/games'));
}

export default function* debtEditSagas() {
    yield all([
        takeLatest(types.GET_GAME.REQUEST, getGameSaga),
        takeLatest(types.GET_GAME.FAILURE, getGameFailure),
        takeLatest(types.SAVE_GAME.REQUEST, saveGameSage)
    ]);
}



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/edit/modules/game-edit-sagas.js